import { render, staticRenderFns } from "./header-profile-dialog.vue?vue&type=template&id=54e5e4d4&scoped=true"
import script from "./header-profile-dialog.vue?vue&type=script&lang=js"
export * from "./header-profile-dialog.vue?vue&type=script&lang=js"
import style0 from "./header-profile-dialog.vue?vue&type=style&index=0&id=54e5e4d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e5e4d4",
  null
  
)

export default component.exports